import { appUrl } from "../../constants/url-constants";
import qs from "querystring";
// eslint-disable-next-line max-params
export const getCarHistoryReportURL = (route = "", query = null, orderId = "") => {
    const queryStr = query ? `?${qs.stringify(query)}` : "";
    const path = `/car-history-check/${orderId}/${route}${queryStr}`;
    return {
        absoluteURL: `${appUrl()}${path}`,
        relativeURL: path
    };
};
